<template>
  <div>
    <v-pagination
      color="primary"
      class="desktop-only"
      :class="$style['custom-pagination-style']"
      :total-visible="7"
      circle
      v-bind="$attrs"
      @input="$emit('input', $event)"
      @next="$emit('next', $event)"
      @previous="$emit('previous', $event)"
    />
    <v-select
      v-bind="$attrs"
      class="mobile-only"
      :class="$style.pagination"
      :items="pages"
      item-text="key"
      item-value="value"
      @input="$emit('input', $event)"
    ></v-select>
  </div>
</template>

<script>
/*
 !!TODO: Must be reviewed after the MVP has been introduced.
 !!This file should be refactored if necessary.

 !! TODO: Remove from base folder
 *----------------------------------------------------------*
 !!author: Christopher Bomm
*/
export default {
  name: 'BasePagination',
  props: {
    page: {
      type: Number,
      default: 1,
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    pages() {
      return [...Array(this.$attrs.length).keys()].map(i => {
        return { key: i + 1, value: i + 1 }
      })
    },
    value() {
      return this.$attrs.value
    },
  },
}
</script>

<style lang="scss" module>
.custom-pagination-style {
  width: auto;
}

.pagination {
  max-width: 3.6rem;

  &--active {
  }
}
</style>
